import React, { useState } from 'react'

import useResponsiveness from '@/shared/hooks/responsive.hooks'
import { Check } from '@mui/icons-material'
import { Box, TextField } from '@mui/material'

import Button from '../Button/Button.component'

import { copyToClipboard } from '../../functions/Clipboard/clipboard.function'
import logger from '../../functions/Logger/logger.functions'
import Snackbar from '../Snackbar/Snackbar.functions'
import { SnackbarAutoHideDuration } from '../Snackbar/Snackbar.types'
import styles from './CopyTextField.styles'
import { CopyTextFieldProps } from './CopyTextField.types'

const CopyTextField: React.FC<CopyTextFieldProps> = (props) => {
  const {
    value,
    label,
    buttonText = 'Copy',
    copiedButtonText = 'Copied',
    successMessage,
    errorMessage = 'Failed to copy',
    containerSx,
    textFieldSx,
    buttonFullWidth,
    variant = 'outlined'
  } = props

  const [isCopied, setIsCopied] = useState(false)
  const [isDesktop] = useResponsiveness()

  const handleCopyClick = async () => {
    try {
      const successfullyCopied = await copyToClipboard(value)

      if (successfullyCopied) {
        setIsCopied(true)

        if (successMessage) {
          Snackbar.show({
            message: successMessage,
            severity: 'success'
          })
        }

        setTimeout(() => {
          setIsCopied(false)
        }, SnackbarAutoHideDuration.SHORT)
      }
    } catch (err) {
      logger.logError(err, errorMessage, 'CopyTextField.handleCopyClick')

      Snackbar.show({
        message: errorMessage,
        severity: 'error'
      })
    }
  }

  return (
    <Box sx={containerSx || styles.container}>
      <TextField
        sx={textFieldSx || styles.textField}
        value={value}
        label={label}
        InputProps={{ readOnly: true }}
        variant={variant}
      />

      <Button
        onClick={handleCopyClick}
        buttonType="primary"
        text={isCopied ? copiedButtonText : buttonText}
        icon={isCopied ? <Check /> : undefined}
        disabled={isCopied}
        fullWidth={buttonFullWidth ?? !isDesktop}
      />
    </Box>
  )
}

export default CopyTextField
